import { render } from "./downloadDepositSubmission.vue?vue&type=template&id=55974797"
import script from "./downloadDepositSubmission.vue?vue&type=script&lang=js"
export * from "./downloadDepositSubmission.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__